import { createAsyncThunk } from "@reduxjs/toolkit";
import { axiosApiInstance } from "@/lib/axios";
import { API_PORTAL_URL } from "@/lib/config";

export const getAllActiveWebHotels = createAsyncThunk(
  "Hotels/HotelsListForWebsite",
  async (formData: unknown) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_PORTAL_URL}/Hotels/HotelsListForWebsite`,
        formData,
      );
      return response.data?.Data;
    } catch (error: unknown) {
      const err = error as { response?: { data?: { Details?: string } } };
      console.error("Error Fetching Hotels:", error);
      return Promise.reject({
        message: err?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);
export const getAllActiveHotels = createAsyncThunk(
  "Hotels/FindAllActiveHotels",
  async (visitDate?: string) => {
    try {
      const response = await axiosApiInstance.get(
        `${API_PORTAL_URL}/Hotels/FindAllActiveHotels`,
        {
          params: visitDate ? { VisitDate: visitDate } : undefined,
        },
      );
      return response.data?.Data;
    } catch (error: unknown) {
      const err = error as { response?: { data?: { Details?: string } } };
      console.error("Error Fetching Hotels:", error);
      return Promise.reject({
        message: err?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const getHotelByURL = createAsyncThunk(
  "Hotels/FindByURLHotels",
  async (URL: string) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_PORTAL_URL}/Hotels/FindByURLHotels`,
        { URL },
      );
      return response.data?.Data;
    } catch (error: unknown) {
      const err = error as { response?: { data?: { Details?: string } } };
      console.error("Error Fetching Hotel:", error);
      return Promise.reject({
        message: err?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const insertWebsiteInquiry = createAsyncThunk(
  "Inquiry/InsertInquiry",
  async (formdata: unknown) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_PORTAL_URL}/Inquiry/InsertInquiry`,
        formdata,
      );
      return response.data?.Data;
    } catch (error: unknown) {
      const err = error as { response?: { data?: { Details?: string } } };
      console.error("Error inserting hotel inquiry:", error);
      return Promise.reject({
        message: err?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

// ─── Server-side fetch functions ─────────────────────────────────────────────

export async function fetchAllActiveWebHotels(formData?: unknown) {
  try {
    const res = await fetch(`${API_PORTAL_URL}/Hotels/HotelsListForWebsite`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(formData || {}),
      next: { revalidate: 1 },
    });
    const json = await res.json();
    return json.Data ?? [];
  } catch {
    return [];
  }
}

// Client-safe fetch (no Next.js cache) — used inside cart modal flow
// same pattern as fetchAllActiveTickets in ticket.services.ts
export async function fetchHotelsForCartModal(visitDate?: string) {
  try {
    const url = visitDate
      ? `${API_PORTAL_URL}/Hotels/FindAllActiveHotels?VisitDate=${visitDate}`
      : `${API_PORTAL_URL}/Hotels/FindAllActiveHotels`;
    const res = await fetch(url, {
      method: "GET",
      headers: { "Content-Type": "application/json" },
      cache: "no-store",
    });
    const json = await res.json();
    return json.Data ?? [];
  } catch (error) {
    console.error("Error fetching hotels for cart modal:", error);
    return [];
  }
}
export async function fetchAllActiveHotels(visitDate?: string) {
  try {
    const url = visitDate
      ? `${API_PORTAL_URL}/Hotels/FindAllActiveHotels?VisitDate=${visitDate}`
      : `${API_PORTAL_URL}/Hotels/FindAllActiveHotels`;
    const res = await fetch(url, {
      method: "GET",
      headers: { "Content-Type": "application/json" },
      next: { revalidate: 1 },
    });
    const json = await res.json();
    return json.Data ?? [];
  } catch {
    return [];
  }
}

export async function fetchHotelByURL(URL: string) {
  try {
    const res = await fetch(`${API_PORTAL_URL}/Hotels/FindByURLHotels`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ URL: URL }),
      next: { revalidate: 30 },
    });
    const json = await res.json();
    return json.Data ?? null;
  } catch {
    return null;
  }
}

// Track third-party booking redirects
// Called before opening hotel.BookingURL in a new tab
export async function insertBookingReference(RoomID: number, URL: string) {
  let geoData = {};
  try {
    const geoRes = await fetch("https://ipapi.co/json/");
    if (geoRes.ok) {
      const data = await geoRes.json();
      geoData = {
        City: data.city || "",
        State: data.region || "",
        Country: data.country_name || "",
        IP: data.ip || "",
        Pincode: data.postal || "",
        Latitude: data.latitude !== undefined ? data.latitude : null,
        Longitude: data.longitude !== undefined ? data.longitude : null,
      };
    }
  } catch (err) {
    console.error("Error fetching geo details from ipapi:", err);
  }

  try {
    const res = await fetch(
      `${API_PORTAL_URL}/Website/InsertBookingReference`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ RoomID, URL, ...geoData }),
        cache: "no-store",
      },
    );
    const json = await res.json();
    return json;
  } catch (error) {
    console.error("Error inserting booking reference:", error);
    return null;
  }
}
